import {
  FETCH_PAGEBYSLUG_REQUEST,
  FETCH_PAGEBYSLUG_SUCCESS,
  FETCH_PAGEBYSLUG_ERROR,
} from '../constants';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_PAGEBYSLUG_REQUEST:
    case FETCH_PAGEBYSLUG_ERROR:
      return state;

    case FETCH_PAGEBYSLUG_SUCCESS:
      return action.payload;
      
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetch_pagebyslug_reducer.js